import styled from 'styled-components';

export const EntriesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const GroupTitle = styled.h2`
  margin-top: 0;
  font-size: 1.5rem;
  color: #222;
  border-bottom: 2px solid #ddd;
  padding-bottom: 5px;
  grid-column: span 2; /* Span across both columns */
`;

export const GlossaryItem = styled.div`
  margin-bottom: 10px;
`;

export const GlossaryTitle = styled.h3`
  margin: 0;
  font-size: 1.1rem;
  color: #333;
`;

export const GlossaryDescription = styled.p`
  margin: 5px 0 0;
  font-size: 0.8rem;
  color: #666;
`;
